var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    color: "currentValue",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18443_5580)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.278248 2.27459C0.100089 2.4504 0 2.68886 0 2.9375V14.1875C0 14.9334 0.300267 15.6488 0.834744 16.1763C1.36922 16.7037 2.09413 17 2.85 17H16.15C16.9059 17 17.6308 16.7037 18.1652 16.1763C18.6997 15.6488 19 14.9334 19 14.1875V4.8125C19 4.56386 18.8999 4.3254 18.7218 4.14959C18.5436 3.97377 18.302 3.875 18.05 3.875H9.8933L8.27161 2.27469C8.09353 2.09886 7.85193 2.00005 7.6 2H0.95C0.698044 2 0.456408 2.09877 0.278248 2.27459ZM12.7613 10.9379C13.3273 10.6518 13.352 9.88563 12.8057 9.56655L7.86555 6.6814C7.31508 6.35992 6.6087 6.73852 6.6087 7.35505V12.7388C6.6087 13.3337 7.27103 13.7148 7.8212 13.4366L12.7613 10.9379Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18443_5580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideo);
export default __webpack_public_path__ + "static/media/ic_video.2ec2e928f01276dcfe8cdbb08aab68b9.svg";
export { ForwardRef as ReactComponent };